import { render, staticRenderFns } from "./Customer-public.vue?vue&type=template&id=c86d1868&"
import script from "./Customer-public.vue?vue&type=script&lang=js&"
export * from "./Customer-public.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports